import React from "react";
import "./DealProducts.css";

// Import default images
import product1 from "../components/assets/images/pro-1.jpg";
import product2 from "../components/assets/images/pro-2.jpg";
import product3 from "../components/assets/images/pro-3.jpg";
import product4 from "../components/assets/images/pro-4.jpg";
import product5 from "../components/assets/images/pro-5.jpg";
import product6 from "../components/assets/images/pro-6.jpg";
import product7 from "../components/assets/images/pro-7.jpg";
import product8 from "../components/assets/images/pro-8.jpg";
import product9 from "../components/assets/images/pro-9.jpg";
import product10 from "../components/assets/images/pro-10.jpg";
import product11 from "../components/assets/images/pro-11.jpg";
import product12 from "../components/assets/images/pro-12.jpg";
import product13 from "../components/assets/images/pro-13.jpg";
import product14 from "../components/assets/images/pro-10.jpg";
// import { BiHeading, BiParagraph } from "react-icons/bi";
import { useCart } from '../components/cart/CartContext';
import { useNavigate } from 'react-router-dom';
const defaultImages = [product1, product2, product3, product4, product5, product6
  , product7, product8, product9, product10, product11, product12, product13, product14,

];

const products = [

  {
    category: "Pure Shilajit",
    price: 191,
    id: 1,
    oldPrice: 240,
    rating: 4,
    BiParagraph: "Prices are inclusive of all taxes",
  },
  {
    category: "Pure Shilajit",
    price: 67,
    id: 2,
    oldPrice: 100,
    rating: 3,
    BiParagraph: "Prices are inclusive of all taxes",
  },
  {
    category: "Pure Shilajit",
    price: 133,
    id: 3,
    oldPrice: 200,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",
  },
  {
    category: "Pure Shilajit",
    price: 259,
    id: 4,
    oldPrice: 350,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",
  },
  {
    category: "Pure Shilajit",
    price: 415,
    id: 5,
    oldPrice: 799,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",
  },
  {
    category: "Pure Shilajit",
    price: 475,
    id: 6,
    oldPrice: 1499,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",
  },
  {
    category: "Pure Shilajit",
    price: 475,
    id: 7,
    oldPrice: 1499,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",
  },
  {
    category: "Pure Shilajit",
    price: 475,
    id: 8,
    oldPrice: 1499,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",
  },
  {
    category: "Pure Shilajit",
    price: 475,
    id: 9,
    oldPrice: 1499,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",
  },
  {
    category: "Pure Shilajit",
    price: 475,
    id: 10,
    oldPrice: 1499,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",
  },
  {
    category: "Pure Shilajit",
    price: 475,
    id: 11,
    oldPrice: 1499,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",
  },
  {
    category: "Pure Shilajit",
    price: 475,
    id: 12,
    oldPrice: 1499,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",
  },
  {
    category: "Pure Shilajit",
    price: 475,
    id: 13,
    oldPrice: 1499,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",
  },
  {
    category: "Pure Shilajit",
    price: 475,
    id: 14,
    oldPrice: 1499,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",
  },
];

const StarRating = ({ rating }) => (
  <div className="star-rating">
    {Array(5)
      .fill(0)
      .map((_, i) => (
        <span key={i} className={i < rating ? "filled" : "empty"}>★</span>
      ))}
  </div>
);

export default function DealProducts() {
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const handleBuyNow = (product) => {
    addToCart(product);
    navigate('/cart');
  };

  return (
    <section className="deal-section">
      <div className="deal-header">
        <div>
          <h2 className="deal-title">
            NEW <span className="highlight">LAUNCHES</span>
          </h2>
          <p className="deal-subtitle">Pick One Do More</p>
        </div>
      </div>

      <div className="product-grid">
        {products.map((product, idx) => {
          const imageSrc = defaultImages[idx % defaultImages.length];

          return (
            <div key={idx} className="product-card">
              <div className="product-image-wrapper">
                <img src={imageSrc} alt={product.category} className="product-image" />
              </div>
              <div className="product-info">
                <p className="category">{product.category}</p>
                <StarRating rating={product.rating} />
                <div className="price-row">
                  <span className="price">₹{product.price}</span>
                  <span className="old-price">₹{product.oldPrice}</span>
                </div>
              </div>
              <h3 className="BiParagraph">{product.BiParagraph}</h3>
              <button className="add-to-cart-btn" onClick={() => handleBuyNow(product)}>
                ADD TO CART
              </button>
            </div>
          );
        })}
      </div>
    </section>
  );
}


